import React from 'react';

export const LenderTable = (props) => (
  <div className='default-table' {...props}>
  </div>
);

export const HeadRow = (props) => (
  <div className='table-head-row' {...props}>
  </div>
);

export const Row = (props) => (
  <div className='table-row' {...props}>
  </div>
);

export const Cell = ({width, ...props}) => (
  <div className='table-cell' style={{width}} {...props}>
  </div>
);

export const SearchBar = (props) => (
  <input type='text' className='search-bar' placeholder='Search' {...props}/>
);

export const Header = () => (
  <div style={{display: 'table', width: 'calc(100%)'}}>
    <HeadRow>
      <Cell attributeName='initials' width='16.6%'>Initials</Cell>
      <Cell attributeName='dob' width='16.6%'>Date of birth</Cell>
      <Cell attributeName='sex' width='16.6%'>Gender</Cell>
      <Cell attributeName='state' width='16.6%'>Status</Cell> 
      <Cell attributeName='orderQuantity' width='16.6%'>Dose</Cell>
      <Cell attributeName='state' width='16.6%'>Status</Cell>
    </HeadRow>
  </div>
);

export const TablePlaceHolder = () => [
  <PlaceHolderRow key={0}/>,
];


export const PlaceHolderRow = index => (
  <Row key={index}>
    <Cell width='15%'></Cell>
    <Cell width='12.5%'></Cell>
    <Cell width='20%'></Cell>
    <Cell width='12.5%'></Cell>
    <Cell width='12.5%'></Cell>
    <Cell width='12.5%'></Cell>
    <Cell width='15%'></Cell>
  </Row>
)


